import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import ApplyPage from "@/pages/ApplyPage";
import AgreementPage from "@/pages/AgreementPage";
import AdminPage from "@/pages/AdminPage";
import ProgramOverviewPage from "@/pages/ProgramOverviewPage";
import ProgramDayPage from "@/pages/ProgramDayPage";
import StoryPage from "@/pages/StoryPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";

function App() {
  useEffect(() => {
    document.title = "Anchor — awareness, presence, intentional action";
  }, []);

  return (
    <div className="App min-h-screen" style={{ backgroundColor: "#F7F5F0" }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/agreement" element={<AgreementPage />} />
          <Route path="/program" element={<ProgramOverviewPage />} />
          <Route path="/program/day/:n" element={<ProgramDayPage />} />
          <Route path="/story" element={<StoryPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#15243D",
            color: "#F7F5F0",
            border: "none",
            borderRadius: "0",
            fontFamily: "Manrope, sans-serif",
            fontWeight: 300,
          },
        }}
      />
    </div>
  );
}

export default App;
